export default __webpack_public_path__ + "4c9968a52f98232eafa7504fc6b49f80.svg";